var map = {
	"./arrow-bold.svg": 8685,
	"./arrow.svg": 970,
	"./calendar.svg": 9165,
	"./caret-down.svg": 2771,
	"./check.svg": 582,
	"./chevron-left.svg": 3977,
	"./chevron-right.svg": 9576,
	"./cog.svg": 6187,
	"./dollar-bill.svg": 3578,
	"./edit.svg": 9147,
	"./exclamation-circle.svg": 436,
	"./exclamation.svg": 977,
	"./eye.svg": 9002,
	"./hamburger.svg": 9970,
	"./logomark.svg": 9483,
	"./logotype.svg": 9703,
	"./menu/bank.svg": 8739,
	"./menu/home.svg": 1032,
	"./menu/reports.svg": 9770,
	"./menu/transactions.svg": 3340,
	"./minus-circle.svg": 5027,
	"./plus-circle.svg": 4521,
	"./progress-bar/debts-active.svg": 5991,
	"./progress-bar/debts.svg": 7108,
	"./progress-bar/emergency-active.svg": 3305,
	"./progress-bar/emergency.svg": 5964,
	"./progress-bar/expense-active.svg": 6555,
	"./progress-bar/expense.svg": 3713,
	"./progress-bar/income-active.svg": 5949,
	"./progress-bar/income.svg": 2729,
	"./question.svg": 349,
	"./review-active.svg": 5935,
	"./search.svg": 4335,
	"./spinner.svg": 7385,
	"./times.svg": 5327,
	"./trash.svg": 1638,
	"./trophy.svg": 4955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2127;